import React, {Component} from "react";
import axios from "axios";
import {stringToColor} from "../utils/color";
import LoaderIcon from "./LoaderIcon";

export default class TemplateBeefreeEditor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true
    };

    this._bee = null;
    this._savePromiseResolve = null;
  }

  componentWillReceiveProps(props) {
    this.create(props);
  }

  componentDidMount() {
    this.create(this.props);
  }

  componentWillUnmount() {
    this._bee = null;
  }

  async create(props) {
    if (props.readOnly) {
      this.setState({loading: false});
      return;
    }
    if (this._bee || !(props.transactional || props.fields) || !props.data || !props.user) {
      return;
    }

    const auth = await axios.get('/api/beefreeauth');
    const token = auth.data;

    const config = {
      uid: props.loggedInImpersonate ? props.loggedInImpersonate : props.user.id,
      container: 'bee-plugin-container',
      disableLinkSanitize: true,
      userColor: stringToColor(props.user.id),
      username: props.user.fullname,
      userHandle: props.user.id,
      editorFonts: {
        showDefaultFonts: true,
        customFonts: [{
            name: "Poppins",
            fontFamily: "'Poppins', sans-serif",
            url: "https://fonts.googleapis.com/css?family=Poppins"
        }]
      },
      specialLinks: [
        {
          type: 'Unsubscribe',
          label: 'Unsubscribe URL',
          link: '{{!!unsublink}}',
        },
        {
          type: 'Unsubscribe',
          label: 'Unsubscribe and Redirect',
          link: '{{!!unsublink|url}}',
        },
        {
          type: 'Unsubscribe',
          label: 'Third Party Unsubscribe',
          link: '{{!!notrack|url}}',
        }
      ],
      mergeTags: this.props.transactional ?
        [{
          name: 'variable',
          value: '{{variable}}'
        }]
        :
        this.props.fields.map(field => {
          return {
            name: field.toString(),
            value: field === 'Email' ? `{{${field}}}` : `{{${field},default=}}`
          };
        }),
      onChange: () => {
        this.props.onChange();
      },
      onSave: (jsonFile, htmlFile) => {
        this.props.update({rawText: {$set: JSON.stringify({
          html: htmlFile,
          json: JSON.parse(jsonFile)
        })}}, this._savePromiseResolve());
      },
    };

    window.BeePlugin.create(token, config, (instance) => {
        this._bee = instance;

        this._bee.start(JSON.parse(props.data.rawText).json);

        props.setSaveCB(() => {
          return new Promise((resolve, reject) => {
            this._savePromiseResolve = resolve;

            this._bee.save();
          });
        });
    });

    this.setState({loading: false});
  }

  render() {
    const {nospace, readOnly, data, fullScreen} = this.props;

    let style = {
      height: 'calc(100vh - 52px)'
    };
    if (!fullScreen) {
      style = {height: 'calc(100vh - 8px)', minHeight: '500px'};
    }

    return (
      <div>
        { !nospace &&
          <div className="space40"></div>
        }
        {
          this.state.loading &&
          <div className="text-center">
            { nospace &&
              <div className="space40"></div>
            }
            <LoaderIcon />
          </div>
        }
        <div id="bee-plugin-container" style={style}>
          { readOnly &&
            <iframe title="template" srcDoc={JSON.parse(data.rawText).html} style={{width: '100%', height: '100%', border: 'none'}} />
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TemplateBeefreeEditor.js